const isEqual = (x, y) => {
  const ok = Object.keys, tx = typeof x, ty = typeof y;
  return x && y && tx === 'object' && tx === ty ? (
    ok(x).length === ok(y).length &&
    ok(x).every(key => isEqual(x[key], y[key]))
  ) : (x === y);
}

export default {
  isEqual,
  isString: (str) => {
    return str != null && typeof str.valueOf() === "string";
  },

  isMobile: () => {
    return window.innerWidth <= 576
  },
  formatDateMonthShortName: (input) => {
    const date = new Date(input)

    const month = date.getMonth()
    const monthNames = [
      "Jan",
      "Feb",
      "Maa",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dec",
    ]

    return monthNames[month]
  },
  formatDateDay: (input) => {
    const date = new Date(input)

    return date.getDate()
  },
  formatDateYear: (input) => {
    const date = new Date(input)

    return date.getFullYear()
  },
  formatDateFull: (input) => {
    const date = new Date(input)
    return date.getDate() + '-' + date.getMonth() + '-' + date.getFullYear();
  }
};
